import memoize from 'lru-memoize';
import { createValidator, required } from 'utils/validation';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
const loginValidation = createValidator({
  username: [required],
  password: required,
});
export default memoize(10)(loginValidation);
